import { createSignalRHub } from '@tpn/redux-observable-signalr-core';
import { of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { RootEpic } from '../../store';
import customerHubEpics, { customerHub } from './hubs/customerHub';
import priceHubEpics, { priceHub } from './hubs/priceHub';
import productHubEpics, { productHub } from './hubs/productHub';
import stockHubEpics, { stockHub } from './hubs/stockHub';
import userHubEpics, { userHub } from './hubs/userHub';
import { startSignalrHubs } from './signalrActions';

const startSignalrHubs$: RootEpic = action$ =>
    action$.pipe(
        filter(startSignalrHubs.match),
        mergeMap(() =>
            of(
                createSignalRHub(priceHub),
                createSignalRHub(stockHub),
                createSignalRHub(userHub),
                createSignalRHub(productHub),
                createSignalRHub(customerHub)
            )
        )
    );

export default [
    startSignalrHubs$,
    ...customerHubEpics,
    ...priceHubEpics,
    ...productHubEpics,
    ...stockHubEpics,
    ...userHubEpics
];
